module.exports = __webpack_public_path__ + "static/media/ideo4.2f88fcb3.jpg";